import { createContext, useContext } from "react";
const ProviderContext = createContext({});
const useProviderContext = () => useContext(ProviderContext);
export {
  ProviderContext,
  useProviderContext
};
//# sourceMappingURL=context.js.map
